import React, { useState, useEffect } from "react";
import Service from "../../assets/svgs/Service.svg";
import { ArrowRight } from "lucide-react";
import leaf from "../../assets/svgs/leaf.svg";
const MealInfoCard = ({
  providerImg,
  thumbnails = [],
  serviceName,
  servieProvider,
  servedTiffins,
  orderAmount,
  onProviderDetail,
  Currency,
  isVeg = false,
}) => {
  // Image carousel logic
  const images = thumbnails.length ? thumbnails : [providerImg];
  const [active, setActive] = useState(0);
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const [loadedCount, setLoadedCount] = useState(0);
  const handleImageLoad = () => {
    setLoadedCount((prev) => {
      const newCount = prev + 1;

      if (newCount === images.length) {
        setImagesLoaded(true);
      }
    
      return newCount;
    });
  };

  const visibleDots = 4;

 

  // DOT WINDOW LOGIC
  const getVisibleDots = () => {
    if (images.length <= visibleDots) {
      return images.map((_, i) => i);
    }

    let start = Math.max(0, active - 1);

    if (start + visibleDots > images.length) {
      start = images.length - visibleDots;
    }

    return Array.from({ length: visibleDots }, (_, i) => start + i);
  };

  const visibleDotIndexes = getVisibleDots();

  return (
    <div>
      {/* Image Carousel */}
      <div className="relative overflow-hidden rounded-xl h-42 w-42 md:w-56 md:h-56 xl:w-64 xl:h-64">
        {/* Shimmer */}
        {!imagesLoaded && (
          <div className="absolute inset-0 animate-pulse bg-gray-200">
            <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 animate-[shimmer_1.5s_infinite]" />
          </div>
        )}

        <div
          className={`flex transition-transform duration-500 ease-in-out ${
            imagesLoaded ? "opacity-100" : "opacity-0"
          }`}
          style={{ transform: `translateX(-${active * 100}%)` }}
        >
          {images.map((img, index) => (
            <img
              key={index}
              src={img}
              alt={serviceName}
              onLoad={handleImageLoad}
              className="w-full h-full object-cover aspect-square"
            />
          ))}
        </div>

        {/* Veg Icon */}
        {isVeg && imagesLoaded && (
          <span className="absolute top-2 right-2 flex items-center justify-center rounded-full bg-green-400 p-1.5 shadow-md">
            <img src={leaf} alt="veg" className="w-3 h-3 object-contain" />
          </span>
        )}

        {/* Dots */}
        {images.length > 1 && imagesLoaded && (
          <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1">
            {visibleDotIndexes.map((index) => (
              <button
                key={index}
                onClick={() => setActive(index)}
                className={`rounded-full transition-all duration-300 ${
                  active === index
                    ? "bg-[#FF6943] h-2 w-2"
                    : "bg-white/70 h-1.5 w-1.5"
                }`}
              />
            ))}
          </div>
        )}
      </div>

      {/* Card Content */}
      <div className="mt-3 space-y-2">
        <h1 className="text-[#191919] text-sm md:text-base font-bold font-manrope line-clamp-1 break-all">
          {serviceName}
        </h1>

        <p className="text-xs md:text-sm text-[#191919] font-manrope line-clamp-1 break-all">
          By {servieProvider}
        </p>

        <div className="flex items-center gap-2 text-sm text-[#828282]">
          <img src={Service} alt="service" className="h-4 w-4 object-contain" />
          <p className="text-xs font-manrope">
            {servedTiffins}
            {servedTiffins > 0 && "+"} Tiffins Served
          </p>
        </div>

        <p className="text-[#FF6943] text-base font-bold font-manrope">
          {Currency}
          {orderAmount}
          <span className="text-sm font-normal text-[#FF6943]"> /Order</span>
        </p>
      </div>

      {/* Button */}
      <button
        className="border border-[#FE6943] text-[#FE6943] font-manrope rounded-full flex justify-center gap-3 items-center cursor-pointer text-xs py-2 px-3 mt-2"
        onClick={onProviderDetail}
      >
        View Details <ArrowRight size={10} />
      </button>
    </div>
  );
};

export default MealInfoCard;
